import { GoogleAnalytics } from "../../googleAnalytics";
import settings from "./_settings";

const scrapeFailed = (provider: String) => {
    GoogleAnalytics.reportEvent({ 
        name: `${settings.scope}:${settings.categoryName}:${provider}:failed`, 
        category: settings.categoryName 
    });
};

export default scrapeFailed;